// @flow
import React from "react";

import SectionHeader from "./commons/SectionHeader";
import Section from "./commons/Section";
import CoverPic from "./commons/CoverPic";

const STYLE_LI = {
  margin: "10px 0",
};

const Histoire = () => {
  return (
    <div style={{}}>
      <SectionHeader>Un terroir durable</SectionHeader>
      <Section>
        <p style={{ textAlign: "justify", margin: 20 }}>
          Comme autrefois, près de Reims à côté d’Épernay, la Maison Champagne
          de Villepin respecte le terroir.
          <br />
          Venez découvrir un champagne subtil et une cuvée authentique.
        </p>
      </Section>
      <CoverPic src="vignes_automne.jpg" />
    </div>
  );
};

export default Histoire;



// WEBPACK FOOTER //
// ./src/Terroir.js